import { Button, List, ListItem, Popover, Stack } from '@mui/material'
import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import ArrowDownCircle from 'src/svgComponents/ArrowDownCircle'
import HomeIcon from 'src/svgComponents/HomeIcon'
import LogoWithText from 'src/svgComponents/LogoWithText'
import AppTooltip from "src/components/common/AppTooltip";
import LocationPin from 'src/svgComponents/LocationPin'
import useLogout from 'src/hooks/useLogout';
import { useSnackbar } from 'notistack'
import { PATH_AUTH, PATH_DASHBOARD } from "src/routes/paths";
import useStore from 'src/contexts/AuthProvider'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
const MainNavbar = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const logout = useLogout();
    const navigate = useNavigate();
    const userData = useStore(state => state);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {
        try {
            await logout();
            // navigate(PATH_AUTH.login);
            handleClose();
        } catch (error) {
            enqueueSnackbar('unable to logout', { variant: 'error' });
        }
    };
    const getProfile = async () => {
        try {
            // await logout();
            navigate(PATH_DASHBOARD.general.getProfile);
            handleClose();
        } catch (error) {
            enqueueSnackbar('unable to get my profile', { variant: 'error' });
        }
    }
    const changePassword = async () => {
        try {
            // await logout();
            navigate(PATH_DASHBOARD.general.changePassword);
            handleClose();
        } catch (error) {
            enqueueSnackbar('unable to get my profile', { variant: 'error' });
        }
    }
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <div className='navbar_wrapper'>
            <div className='navbar_container'>
                <div className='logo_container'>
                    <NavLink to="/dashboard/" className='text-decoration-none'><LogoWithText /></NavLink>
                </div>
                <div className='navbar_config_container'>
                    <div className='app_text_16_500 text-white'>
                        {userData.name}
                    </div>
                    <div>
                        <Button disableRipple onClick={(e) => handleClick(e)} className='main_nav_config_btn h-100'><ArrowDownCircle /></Button>
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <div className='logout_popover_content'>
                                <List disablePadding>
                                    <ListItem>
                                        <Stack spacing={1} className="logout_popover_content_header">
                                            <div className='d-flex flex-column'>
                                                <span className='app_text_14_semibold'>{userData.name}</span>
                                                <span className='app_text_12_fw500 app_text_gray'>{userData.role}</span>
                                            </div>
                                            {/* <span className='app_text_12_semibold app_text_black_3'>{userData.email}</span> */}
                                        </Stack>
                                    </ListItem>
                                    <ListItem>
                                        <NavLink to={PATH_DASHBOARD.general.getProfile} className="d-flex align-items-center" style={{ textDecoration: "none" }}>
                                            <AccountCircleOutlinedIcon className="app_text_14 app_text_black d-flex align-items-center" style={{ height: "20", width: "20", textDecoration: "none" }} />

                                            <span className='app_text_14 app_text_black d-flex align-items-center ms-3'>
                                                My Profile
                                            </span>
                                        </NavLink>
                                    </ListItem>
                                    <ListItem>
                                        <NavLink to={PATH_DASHBOARD.general.changePassword} className="d-flex align-items-center" style={{ textDecoration: "none" }}>
                                            <LockOutlinedIcon className="app_text_14 app_text_black d-flex align-items-center" style={{ height: "20", width: "20" }} />

                                            <span className='app_text_14 app_text_black d-flex align-items-center ms-3' >Change password</span>
                                        </NavLink>
                                    </ListItem>
                                    <ListItem>
                                        <NavLink to={PATH_AUTH.login} className="d-flex align-items-center" style={{ textDecoration: "none" }} onClick={() => handleLogout()}>
                                            <LogoutOutlinedIcon className="app_text_14 app_text_black d-flex align-items-center" style={{ height: "20", width: "20" }} />

                                            <span className='app_text_14 app_text_black d-flex align-items-center ms-3'>Logout</span>
                                        </NavLink>
                                    </ListItem>
                                </List>
                            </div>
                        </Popover>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainNavbar